export const SITE = {
  name: "TRX Auto Sales & Service Inc",
  phone: "(704) 380-4555",
  phoneHref: "tel:+17043804555",
  smsHref: "sms:+17043804555",
  email: "TRX82@hotmail.com",
  address: "120 Bristol Rd, Statesville, NC 28677",
  mapsEmbed:
    "https://maps.google.com/maps?q=120%20Bristol%20Rd%2C%20Statesville%2C%20NC%2028677&t=&z=14&ie=UTF8&iwloc=&output=embed",
  hours: [
    { day: "Monday – Friday", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 2:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  facebook: "https://www.facebook.com/share/1DSB4MkFUu/?mibextid=wwXIfr",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=2000&q=85",
  shop: "https://images.unsplash.com/photo-1618642624018-a370cbf3cd80?auto=format&fit=crop&w=1600&q=80",
  repairBay: "https://images.unsplash.com/photo-1596986952526-3be237187071?auto=format&fit=crop&w=1600&q=80",
  engineBay: "https://images.unsplash.com/photo-1552656967-7a0991a13906?auto=format&fit=crop&w=1600&q=80",
  perfParts: "https://images.unsplash.com/photo-1527383418406-f85a3b146499?auto=format&fit=crop&w=1600&q=80",
  porscheDark: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1600&q=80",
  porsche911: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1600&q=80",
  bmwBlue: "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=1600&q=80",
  bmwDark: "https://images.unsplash.com/photo-1553440569-bcc63803a83d?auto=format&fit=crop&w=1600&q=80",
  bmwSilver: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=1600&q=80",
  amgGt: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1600&q=80",
  audiNight: "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=1600&q=80",
  corvette: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1600&q=80",
  carNight: "https://images.unsplash.com/photo-1494905998402-395d579af36f?auto=format&fit=crop&w=1600&q=80",
  road: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1600&q=80",
  mEngine: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1600&q=80",
  wrenching: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&w=1600&q=80",
  mercedes: "https://images.unsplash.com/photo-1584060622420-0673aad46076?auto=format&fit=crop&w=1600&q=80",
};

export const SERVICES = [
  {
    num: "01",
    title: "Automotive Diagnostics",
    desc: "Advanced diagnostics using professional equipment to accurately identify and repair vehicle issues.",
    items: ["Dealer-level scan tools", "Electrical fault tracing", "European vehicle specialists", "Check engine & drivability"],
    image: IMG.repairBay,
  },
  {
    num: "02",
    title: "Maintenance",
    desc: "Factory-scheduled maintenance performed with premium parts and obsessive attention to detail.",
    items: ["Oil changes", "Brakes", "Tires", "Batteries", "Cooling systems", "Preventative maintenance"],
    image: IMG.shop,
  },
  {
    num: "03",
    title: "Repairs",
    desc: "From engine work to electrical systems — repaired right the first time, backed by honest communication.",
    items: ["Engine repair", "Suspension", "Electrical", "Transmission service", "Cooling system repairs", "Steering"],
    image: IMG.wrenching,
  },
  {
    num: "04",
    title: "Performance Upgrades",
    desc: "Builds engineered for power, balance, and reliability — from bolt-ons to full custom projects.",
    items: ["Downpipes", "Intercoolers", "Exhaust systems", "Coilovers", "Turbo upgrades", "Wheels", "Custom builds"],
    image: IMG.engineBay,
  },
];

export const REVIEWS = [
  {
    quote: "Professional service, honest pricing, and great communication.",
    author: "Marcus D.",
    detail: "BMW M4 Service",
  },
  {
    quote: "TRX treated my vehicle like their own.",
    author: "Jennifer R.",
    detail: "Mercedes-AMG Repair",
  },
  {
    quote: "Best automotive experience I've had.",
    author: "Chris T.",
    detail: "Performance Build",
  },
  {
    quote: "They diagnosed what two other shops couldn't. Won't take my cars anywhere else.",
    author: "Alonzo W.",
    detail: "Porsche Diagnostics",
  },
];

export const GALLERY_CATEGORIES = ["Vehicle Inventory", "Performance Builds", "Repairs", "Shop Life", "Customer Deliveries"];

export const MARQUEE_ITEMS = [
  "Precision",
  "Performance",
  "Trust",
  "European Specialists",
  "Dealer-Level Diagnostics",
  "Custom Builds",
  "Statesville · Charlotte NC",
];
